import {
  SectionContainer,
  SectionTitle,
  StateMessageContainer,
  StateMessage,
} from '../styles';

export const TeamSectionError = () => (
  <SectionContainer>
    <StateMessageContainer maxWidth="lg">
      <SectionTitle sx={{ mb: 4 }}>What Sets Our Team Apart</SectionTitle>
      <StateMessage color="error">
        Unable to load practitioners. Please try again later.
      </StateMessage>
    </StateMessageContainer>
  </SectionContainer>
);

export const TeamSectionEmpty = () => (
  <SectionContainer>
    <StateMessageContainer maxWidth="lg">
      <SectionTitle sx={{ mb: 4 }}>What Sets Our Team Apart</SectionTitle>
      <StateMessage>No practitioners available at the moment.</StateMessage>
    </StateMessageContainer>
  </SectionContainer>
);

export const TeamSectionNoResults = () => (
  <StateMessageContainer maxWidth="lg">
    <StateMessage>No practitioners match your selected filters.</StateMessage>
  </StateMessageContainer>
);
